export default {
    actions: 'Actions',
    admin: 'Admin',
    address: 'Adresse',
    all: 'Tous',
    availability: 'Disponibilité',
    awaitingApproval: "En attente d'approbation",
    back: 'Retour',
    business: 'Entreprise',
    businesses: 'Entreprises',
    cancel: 'Annuler',
    categories: 'Catégories',
    category: 'Catégorie',
    comingSoon: {
        title: 'Cette fonctionnalité est actuellement en développement.',
        message: 'Veuillez revenir plus tard pour des mises à jour.',
    },
    confirm: 'Confirmer',
    contact: 'Contact',
    continue: 'Continuer',
    description: 'Description',
    edit: 'Modifier',
    email: 'Courriel',
    english: 'Anglais',
    followers: 'Abonnés',
    following: 'Abonnements',
    french: 'Français',
    hour: 'Heure',
    hours: 'Heures',
    influencer: 'Influenceur',
    instagram: 'Instagram',
    login: 'Connexion',
    logout: 'Déconnexion',
    next: 'Suivant',
    offer: 'Offre',
    optional: 'Optionnel',
    phone: 'Téléphone',
    posts: 'Publications',
    reject: 'Rejeter',
    remove: 'Retirer',
    reward: 'Récompense',
    stories: 'Stories',
    reels: 'Reels',
    claimLink: {
        title: 'Ouvrez ceci dans l’application INVI',
        description: 'Cette conversation se trouve dans l’application INVI. Ouvrez-la pour répondre, ou installez l’application si vous ne l’avez pas encore.',
        openApp: 'Ouvrir dans l’application',
        appStore: 'Télécharger sur l’App Store',
        playStore: 'Disponible sur Google Play',
        desktopTitle: 'Ouvrez ceci sur votre téléphone',
        desktopDescription: 'INVI est une application mobile. Ouvrez ce lien sur le téléphone où INVI est installé pour poursuivre la conversation.',
    },
    close: 'Fermer',
    day: 'Jour',
    days: 'Jours',
    disabled: 'Désactivée',
    draft: 'Brouillon',
    drafts: 'Brouillons',
    finishSetup: 'Terminer la configuration',
    live: 'En ligne',
    manage: 'Gérer',
    more: 'Plus',
    new: 'Nouveau',
    newCount_one: '{{count}} nouveau',
    newCount_other: '{{count}} nouveaux',
    newRequests: 'Nouvelles demandes',
    notSubmitted: 'Non soumis',
    notValid: 'invalide',
    of: 'de',
    offers: 'Offres',
    offersCount_one: '{{count}} offre',
    offersCount_other: '{{count}} offres',
    open: 'Ouvert',
    pending: 'En attente',
    photos: 'Photos',
    profile: 'Profil',
    request: 'Demande',
    requests: 'Demandes',
    show: 'Afficher',
    showThem: 'Les montrer',
    submit: 'Envoyer',
    submitted: 'Soumis',
    unfinished: 'Non terminé',
    viewSubmission: 'Voir la soumission',
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    weekend: 'Weekend',
    weekends: 'Weekends',
};
